export default "__VITE_ASSET__26DFRYhM__"